import { TranslateService } from "@ngx-translate/core";
import { translateCode } from "../shared/utils/translate-code";
import { AbstractEntity } from "./abstract-entity";
import { OrderProduct } from "./order-product";
import { DeliveryAddress } from "./DeliveryAddress";
import { PromoCode } from "./promoCode";
import { Transaction } from "./transaction";

type Delivery = {
  deliveryType:
    | "DOMICILE"
    | "POINT_DE_RELAIT"
    | "NO_DELIVERY"
    | "RECUPERATION_AU_NIVEAU_DU_MAGASIN"
    | "DELIVERY_BY_TAXI";
  deliveryAddress: DeliveryAddress;
  livreurId: number;
  deliveryPrice: number;
};

export interface Order extends AbstractEntity<number> {
  clientId: number;
  state: string;
  folderId: number;
  folderState: string;
  orderItems: OrderProduct[];
  delivery: Delivery;
  createdAt?: string;
  totalTTC: number;
  total: number;
  tracking: string;
  paymentReceipt?: string;
  paymentReceiptComment?: string;
  promoCodeTO: PromoCode;
  paymentMethod: "CASH_EN_DELIVERY" | "CIB_ELDAHABIA" | "VIREMENT";
  paymentState: "NOT_READY" | "PAYED" | "FAILED" | "RECEIVABLE" | "READY";
  transactions: Transaction[];
  imgUrls?: string[];
  image: string[];
}

export const ORDER_STATE_LABELS: Record<string, string> = {
  PAID_DELIVERED: "Livrée",
  NOT_PAID_IN_DELIVERY: "En cours de livraison",
  PAID_IN_DELIVERY: "En cours de livraison",
  NOT_PAID_PREPARED: "En préparation",
  PAID_PREPARED: "En préparation",
  CREATED: "En attente",
  NOT_PAID: "En attente",
  WAITING_FOR_CLIENT: "En attente du client",
  CLIENT_NOT_RESPONDING: "Client ne répond pas",
  CONFIRMED: "Confirmée",
  NOT_PAID_NOT_DELIVERY: "En attente de paiement",
  PAID: "Payée",
  PAID_NOT_DELIVERED: "Payée",
  PAID_FAILED: "Paiement échoué",
  PAID_FAILED_NOT_DELIVERED: "Paiement échoué",
  NOT_PAID_READY: "Prête",
  PAID_READY: "Prête",
  NOT_PAID_RETURNED: "Retournée",
  PARTIALLY_DELIVERED: "Partiellement livrée",
  CANCELED: "Annulée",
};

export function mapOrderState(state?: string): string {
  return state ? (ORDER_STATE_LABELS[state] ?? state) : "";
}

/**
 * "Commande livrée": order state label in the current language (`shared.states.<STATE>` inside
 * `shared.orderState`), falling back to the French label above for states without a translation.
 */
export function translateOrderState(
  translate: TranslateService,
  state?: string,
): string {
  const label = translateCode(translate, "shared.states", state, mapOrderState);
  return translate.instant("shared.orderState", { state: label.toLowerCase() });
}
